/**
* @file 运营中心-平台管理
* */
<template>
  <div id="schedulingTabs">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content" v-show="tabs.length > 0">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "schedulingTabs",
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.tabAction = to.path
    })
  },
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({ 'permissionsGetter': 'permissionsGetter' })
  },
  watch: {
    permissionsGetter: {
      handler(val) {
        if (val && val.length > 0 && this.tabs.length === 0) {
          this.buildTabs();
        }
      },
      immediate: true,
    },
    tabAction(val) {
      this.$router.push(val);
    },
    $route: {
      handler(val) {
        this.tabAction = val.path;
        if (val.path == '/scheduling' && this.tabs.length > 0) {
          this.$nextTick(() => {
            this.tabAction = this.tabs[0].name;
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.mixinOrganizations();
    this.buildTabs();
  },
  methods: {
    buildTabs() {
      let tabs = [];
      if (this.menuPreFn(65)) tabs.push({ label: "定制客运", name: "/customize", icon: 'el-icon-document' });
      if (this.menuPreFn(66)) tabs.push({ label: "班线客运", name: "/line", icon: 'el-icon-tickets' });
      if (tabs.length > 0) {
        this.tabs = tabs;
        this.tabAction = this.tabAction && this.tabAction !== '/scheduling' ? this.tabAction : tabs[0].name;
      }
    }
  },
};
</script>

<style lang="less">
#schedulingTabs {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    &>div {
      height: 100%;
    }
  }
}
</style>
